import React, { ReactNode, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import Close from "src/assets/icons/close.svg";
import Arr from "src/assets/icons/chevron-left.svg";

import styles from "src/components/organisms/Modal/styles.module.css";
import cx from "classnames";
import { useLocation } from "react-router-dom";

type Props = {
  children: ReactNode;
  isVisible: boolean;
  closeModal: () => void;
  className?: string;
  isShowClose?: boolean;
  onClick?: () => void;
  fromBottom?: boolean;
  withoutClose?: boolean;
  disableOutsideClickClose?: boolean;
  closeIconMode?: "theme" | "black" | "white";
};

export const Modal: React.FC<Props> = ({
  children,
  isVisible,
  closeModal,
  className,
  isShowClose = true,
  onClick,
  fromBottom = false,
  withoutClose = false,
  disableOutsideClickClose = false,
  closeIconMode = "theme",
}) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const isTelegram = params.get("isTelegram") === "true";
  const modalRef = useRef<HTMLDivElement | null>(null);
  const domEl = document.getElementById("root");

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        disableOutsideClickClose ||
        !modalRef.current ||
        modalRef.current.contains(event.target as Node) ||
        isTelegram
      ) {
        return;
      }
      closeModal();
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape" && !isTelegram) {
        closeModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isVisible, disableOutsideClickClose]);

  if (!domEl || !isVisible) return null;

  return ReactDOM.createPortal(
    <div className={styles.modalOverlay}>
      <div
        className={cx(styles.modal, className, fromBottom && styles.fromBottom)}
        ref={modalRef}
      >
        {fromBottom && (
          <div className={styles.lini} onClick={closeModal} role="button" />
        )}
        {fromBottom ||
          (!withoutClose && !disableOutsideClickClose && !isTelegram && (
            <>
              {isShowClose ? (
                <div
                  className={cx(
                    styles.close,
                    closeIconMode === "black" && styles.closeBlack,
                    closeIconMode === "white" && styles.closeWhite
                  )}
                  onClick={closeModal}
                  role="button"
                >
                  <img src={Close} alt="close" />
                </div>
              ) : (
                <div className={styles.left} onClick={onClick} role="button">
                  <img src={Arr} alt="close" />
                </div>
              )}
            </>
          ))}

        {children}
      </div>
    </div>,
    domEl
  );
};
